const API_BASE = "https://saurusrehv-backend.azurewebsites.net/api/articles";

export default {
  namespaced: true,
  state: () => ({
    listsByKey: {},
    lastQueryKey: "",
    loading: false,
    error: null,
    articleMap: {},
    // Last search per catalogue tab ("tyres" / "wheels").
    savedSearches: {},
  }),
  getters: {
    articles(state) {
      const entry = state.listsByKey[state.lastQueryKey];
      return entry ? entry.items : [];
    },
    isLoading: (state) => state.loading,
    error: (state) => state.error,
    hasArticles(state) {
      const entry = state.listsByKey[state.lastQueryKey];
      return Boolean(entry && entry.items && entry.items.length);
    },
    getArticleById: (state) => (id) => {
      const numericId = Number(id);
      if (Number.isNaN(numericId)) return null;
      return state.articleMap[numericId] || null;
    },
    currentQueryKey: (state) => state.lastQueryKey,
    savedSearch: (state) => (category) => state.savedSearches[category] || null,
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERROR(state, value) {
      state.error = value;
    },
    SET_LAST_QUERY_KEY(state, key) {
      state.lastQueryKey = key;
    },
    STORE_ARTICLES(state, { queryKey, items }) {
      state.listsByKey[queryKey] = { items };
      state.lastQueryKey = queryKey;
      if (Array.isArray(items)) {
        items.forEach((item) => {
          if (item && item.ArticleId != null) {
            state.articleMap[item.ArticleId] = item;
          }
        });
      }
    },
    UPSERT_ARTICLE(state, article) {
      if (!article || article.ArticleId == null) return;
      state.articleMap[article.ArticleId] = article;
      const currentList = state.listsByKey[state.lastQueryKey];
      if (currentList && Array.isArray(currentList.items)) {
        const index = currentList.items.findIndex(
          (item) => item && item.ArticleId === article.ArticleId
        );
        if (index !== -1) {
          currentList.items.splice(index, 1, article);
        }
      }
    },
    SAVE_SEARCH(state, { category, search }) {
      state.savedSearches[category] = search ? { ...search } : null;
    },
  },
  actions: {
    async fetchArticles(
      { commit, state },
      { queryKey = "", force = false } = {}
    ) {
      const key = queryKey || "";
      commit("SET_LAST_QUERY_KEY", key);

      const cached = state.listsByKey[key];
      if (cached && !force) {
        commit("SET_ERROR", null);
        commit("SET_LOADING", false);
        return cached.items;
      }

      commit("SET_LOADING", true);
      commit("SET_ERROR", null);

      try {
        const url = key ? `${API_BASE}?${key}` : API_BASE;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Viga laadimisel: ${response.status}`);
        }
        const data = await response.json();
        const items = Array.isArray(data) ? data : [];
        commit("STORE_ARTICLES", { queryKey: key, items });
        return items;
      } catch (err) {
        const message = err?.message || "Tundmatu viga andmete laadimisel";
        commit("SET_ERROR", message);
        throw err;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    upsertArticle({ commit }, article) {
      commit("UPSERT_ARTICLE", article);
    },
    clearError({ commit }) {
      commit("SET_ERROR", null);
    },
    saveSearch({ commit }, { category, search }) {
      commit("SAVE_SEARCH", { category, search });
    },
  },
};
